import React, { useEffect, useRef, useState } from "react";
import { CustomModal } from "../../../../components/customModal";
import { useCssStyle } from "../../../../customHook/getCssStyle";
import { isIOS, isWeb } from "../../../../utils/Helper";
import { NativeModules, Platform, SafeAreaView, StatusBar, StyleSheet, Text, View } from "react-native";
import WebView from "react-native-webview";
import { COLORS } from "../../../../style";
import CustomPressable from "../../../../components/customPressable/customPressable";
import { ImageComp } from "../../../../components/Image/Image";
import { CROSS } from "../../../../assets";
import { MOBILE_CHECKIN_CATEGORY } from "../../../../config/Constant";
import { useDispatch } from "react-redux";
import { sendAnalytics } from "../../../../Redux/Actions/analyticsAction";

const { StatusBarManager } = NativeModules;

export const ElavonCardContainerModal = ({ checkinSessionToken, iframeurl, handleSuccess, handleError, handleClose }) => {

    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const [statusBarHeight, setStatusBarHeight] = useState(0);

    const webViewRef = useRef(null);
    const iframeRef = useRef(null);

    const getStatusBarHeight = () => {
        if (Platform.OS === 'ios') {
            StatusBarManager.getHeight((height) => setStatusBarHeight(height.height || 0));
        } else {
          setStatusBarHeight(StatusBar.currentHeight || 0);
        }
    }


    const handleOnMessageReceive = (event) => {
        try {
            if (isWeb() && !iframeurl.includes(event.origin)) {
                return;
            }
            const message = isWeb() ? JSON.parse(event.data) : JSON.parse(event.nativeEvent.data);
            console.log("elavonLB rn: ", message);


            if (message.status == "approved") {

                handleSuccess(message.response)
                return;
            }

            if (message.status == "declined") {
                handleError(message.response.ssl_result_message)
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": message.response.ssl_result_message }));
                return;
            }

            if (message.status == "error") {
                handleError(message.response)
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": message.response}));
                return;
            }
            // if (message.status == "cancelled") {
            //     handleError("Card validation cancelled")
            //     return;
            // }
        } catch (error) {
            console.log('Error in onMessage:', error);
            handleError(error?.message || "Something went wrong");
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": error?.message || "Error during card validation" }));
        }
    };

    // Add event listener for web platform
    useEffect(() => {
        getStatusBarHeight();
        if (isWeb()) {
            window.addEventListener("message", handleOnMessageReceive);
        }

        return () => {
            if (isWeb()) {
                window.removeEventListener("message", handleOnMessageReceive);
            }
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <CustomModal>

            <View style={getStyles(['elavonCardContainer', {marginTop: isIOS() ? statusBarHeight : 0}])}>
                {isWeb() ? (
                    <iframe
                        ref={iframeRef}
                        src={iframeurl}
                        style={getStyles(['elavonCardContainer_iframe'])}
                        title="ElavonLB"
                    />
                ) : (
                    <WebView
                        ref={webViewRef}
                        style={getStyles(['elavonCardContainer_webview'])}
                        originWhitelist={['*']}
                        source={{ uri: iframeurl }}
                        onMessage={handleOnMessageReceive}
                        showsVerticalScrollIndicator={false}
                        startInLoadingState={true}
                        javaScriptEnabled={true}
                        onError={(error) => console.log(error)}
                        webviewDebuggingEnabled={true}
                        pullToRefreshEnabled={false}
                        cacheEnabled={false}
                    />
                )}

                <SafeAreaView style={getStyles(['safeArea', 'crossOverContainer_Container'])}>
                    <CustomPressable style={getStyles(['crossOverContaniner_Cross'])} onPress={handleClose}>
                        <ImageComp source={CROSS} />
                    </CustomPressable>
                </SafeAreaView>
            </View>
        </CustomModal>
    )
}